import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";

const FAQS = [
  {
    q: "Perché pagare una consulenza invece di chiamare una ditta?",
    a: "Una ditta di disinfestazione chiede tra i 250€ e i 600€ a intervento, spesso usando prodotti sovrapprezzati. Con 60€+IVA ti rivelo il prodotto professionale esatto da acquistare in agraria oppure online e la procedura corretta. Risolvi da solo spendendo una frazione.",
  },
  {
    q: "Cosa succede dopo il pagamento?",
    a: "Subito dopo il pagamento vedi il tuo Voucher univoco e il pulsante per scrivermi direttamente su WhatsApp. Mi mandi foto del problema col tuo codice e fissiamo la chiamata nell'orario per te più comodo, spesso in giornata.",
  },
  {
    q: "Bastano davvero 10-20 minuti?",
    a: "Sì, fino a 10 minuti con la Consulenza Base e fino a 20 con la Premium. Il segreto è che prima della chiamata ho già analizzato le tue foto e identificato la specie, quindi in chiamata andiamo dritti alla soluzione, ovvero prodotto, dosi, punti di applicazione e prevenzione.",
  },
  {
    q: "Rilasciate fattura fiscale?",
    a: "Certamente. Sia per privati (con Codice Fiscale) che per Partite IVA e aziende, con fatturazione elettronica.",
  },
];

export const Faq = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="max-w-4xl mx-auto px-6 py-24">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="text-center"
      >
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-terracotta font-bold mb-4">
          Domande frequenti
        </p>
        <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl tracking-tight text-moss">
          Tutto chiaro, <span className="italic text-mosslight">prima di pagare.</span>
        </h2>
      </motion.div>
      <div className="mt-12 space-y-4">
        {FAQS.map((f, i) => {
          const isOpen = open === i;
          return (
            <div
              key={f.q}
              data-testid={`faq-accordion-item-${i}`}
              className="rounded-3xl bg-white border border-line overflow-hidden"
            >
              <button
                onClick={() => setOpen(isOpen ? -1 : i)}
                data-testid={`faq-question-${i}`}
                className="flex w-full items-center justify-between gap-4 px-7 py-5 text-left"
              >
                <span className="text-base font-semibold text-ink">{f.q}</span>
                <ChevronDown
                  size={18}
                  className={`shrink-0 text-terracotta transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
                />
              </button>
              <AnimatePresence initial={false}>
                {isOpen && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                  >
                    <p className="px-7 pb-6 text-sm leading-relaxed text-sub">{f.a}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          );
        })}
      </div>
    </section>
  );
};
